<style>
.inspection-detail-modal.large-popup .vs-popup {
    width: 1000px;
}
.inspection-detail-modal .ag-theme-material .ag-cell {
    line-height: 35px !important;
}
/* Sejajarkan ringkasan header dengan teks kolom pertama ag-grid
   (ag-theme-material .ag-cell / .ag-header-cell padding-left: 24px). */
.inspection-detail-modal .inspection-meta {
    margin: 0;
    padding-left: 24px;
}
.inspection-detail-modal .inspection-meta .vx-col {
    padding-left: 0;
}
/* Title popup sejajar juga: .vs-popup--content padding 13px + ag-cell 24px = 37px. */
.inspection-detail-modal .vs-popup--title h3 {
    padding-left: 37px;
}

/* $vs.dialog() selalu mount ke document.body (prop `parent` tidak dihormati
   di vuesax@3.9.0), jadi dialog konfirmasi delete ketutup popup ini
   (.con-vs-popup z-index 53000 > .con-vs-dialog 52005, lihat _fixesVuesax.scss).
   Body diberi class saat modal ini aktif (lihat watcher `active`) supaya
   dialog konfirmasi naik di atas popup. */
body.inspection-modal-open .con-vs-dialog {
    z-index: 53100;
}

.inspection-detail-modal .inspection-export-btn {
    position: absolute;
    top: 10px;
    right: 13px;
}
.inspection-detail-modal .inspection-meta-label {
    display: block;
    padding: 0;
    margin-bottom: 2px;
    font-size: 0.85rem;
    color: rgba(0, 0, 0, 0.6);
}
.inspection-detail-modal .inspection-meta-value {
    margin: 0;
    font-weight: 600;
}
</style>

<template>
    <vs-popup
        class="inspection-detail-modal large-popup"
        title="Detail Inspeksi"
        :active="active"
        @update:active="$emit('update:active', $event)"
    >
        <div v-if="inspection" class="vx-row inspection-meta mb-4" style="position: relative;">
            <div class="vx-col w-1/2 md:w-1/5 mb-2">
                <label class="inspection-meta-label">ID Inspeksi</label>
                <p class="inspection-meta-value">{{ inspection.inspection_id }}</p>
            </div>
            <div class="vx-col w-1/2 md:w-1/5 mb-2">
                <label class="inspection-meta-label">Tanggal Inspeksi</label>
                <p class="inspection-meta-value">{{ inspection.inspection_date }}</p>
            </div>
            <div class="vx-col w-1/2 md:w-1/5 mb-2">
                <label class="inspection-meta-label">Warehouse</label>
                <p class="inspection-meta-value">{{ inspection.warehouse_code }}</p>
            </div>
            <div class="vx-col w-1/2 md:w-1/5 mb-2">
                <label class="inspection-meta-label">Product Code</label>
                <p class="inspection-meta-value">{{ inspection.product_code }}</p>
            </div>
            <div class="vx-col w-1/2 md:w-1/5 mb-2">
                <label class="inspection-meta-label">Quantity</label>
                <p class="inspection-meta-value">{{ inspection.quantity }}</p>
            </div>
            <vs-button class="inspection-export-btn" color="success" icon="file_download" @click="exportInspection">Export</vs-button>
        </div>

        <ag-grid-vue
            :gridOptions="gridOptions"
            class="ag-theme-material w-100 my-4 ag-grid-table"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="items"
            colResizeDefault="shift"
            :animateRows="false"
            @cell-clicked="onCellClicked"
        ></ag-grid-vue>
        <p class="text-right">
            <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
        </p>
        <vs-pagination
            :total="totalPage"
            v-model="currentPage"
            :max="7"
        ></vs-pagination>
    </vs-popup>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { renderDeleteButton, findActionTarget } from "./actionCell";
import "./actionCell.css";

export default {
    components: {
        AgGridVue,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        inspection: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            isLoading: false,
            items: [],
            gridOptions: {},
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
            },
            columnDefs: [
                { headerName: "Tanggal Inspeksi", field: "inspection_date", width: 150 },
                { headerName: "Warehouse", field: "warehouse_code", width: 140 },
                { headerName: "Product Code", field: "product_code", width: 150 },
                { headerName: "Serial Number", field: "serial_number", width: 160 },
                { headerName: "Qty", field: "qty", width: 90, type: "numericColumn" },
                { headerName: "Informasi", field: "information", width: 180 },
                {
                    headerName: "Action",
                    field: "id",
                    sortable: false,
                    width: 120,
                    cellRenderer: (params) => renderDeleteButton(params.value),
                },
            ],
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        };
    },
    watch: {
        isLoading(val) {
            if (val) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        active(val) {
            document.body.classList.toggle("inspection-modal-open", val);
            if (val && this.inspection) {
                this.currentPage = 1;
                this.fetchItems();
            }
        },
        currentPage() {
            if (this.active) {
                this.fetchItems();
            }
        },
    },
    methods: {
        async exportInspection() {
            this.isLoading = true;
            try {
                const response = await this.$http.get(
                    `tvd/inspection/${this.inspection.id}/export`,
                    { responseType: "blob" }
                );
                const blob = new Blob([response.data], { type: "text/csv;charset=utf-8" });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.download = `inspection_${this.inspection.inspection_id}_${Date.now()}.csv`;
                link.click();
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.notifyError(error, "Gagal export inspeksi.");
            } finally {
                this.isLoading = false;
            }
        },
        async fetchItems() {
            if (!this.inspection) return;

            this.isLoading = true;
            try {
                const resp = await this.$http.get(`tvd/inspection/show/${this.inspection.id}`);
                const inspection = resp.data.data;
                const allDetails = (inspection.details || []).map((row) => ({
                    id: row.id,
                    inspection_date: row.date,
                    warehouse_code: row.warehouse_code,
                    product_code: row.product_code,
                    serial_number: row.serial_number,
                    qty: row.qty,
                    information: row.information,
                }));

                const perPage = 10;
                const lastPage = Math.max(1, Math.ceil(allDetails.length / perPage));
                const currentPage = Math.min(Math.max(1, this.currentPage), lastPage);
                const from = allDetails.length ? (currentPage - 1) * perPage + 1 : 0;
                const to = Math.min(currentPage * perPage, allDetails.length);

                this.items = allDetails.slice((currentPage - 1) * perPage, currentPage * perPage);
                this.totalPage = lastPage;
                this.dataTotal = allDetails.length;
                this.dataFrom = from;
                this.dataTo = to;
                this.isLoading = false;
            } catch (error) {
                this.notifyError(error, "Gagal memuat detail inspeksi.");
            }
        },
        onCellClicked(params) {
            const target = findActionTarget(params.event);
            if (!target) return;

            if (target.getAttribute("data-action") === "delete") {
                this.confirmDelete(params.data);
            }
        },
        confirmDelete(item) {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Konfirmasi Hapus",
                text: `Hapus item inspeksi ini?`,
                acceptText: "Hapus",
                cancelText: "Batal",
                accept: () => this.deleteItem(item),
            });
        },
        async deleteItem(item) {
            this.isLoading = true;
            try {
                const resp = await this.$http.delete(`tvd/inspection/detail/${item.id}`);
                this.isLoading = false;
                this.$vs.notify({
                    color: "success",
                    title: "Success",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: resp.data.message,
                });
                const quantity = Math.max(
                    0,
                    Number(this.inspection.quantity || 0) - Number(item.qty || 0)
                );
                this.$emit("item-deleted", { inspection: this.inspection, quantity });
                this.refreshAfterDelete();
            } catch (error) {
                this.notifyError(error, "Gagal menghapus item inspeksi.");
            }
        },
        refreshAfterDelete() {
            // Kalau halaman aktif jadi kosong setelah hapus, mundur satu halaman.
            const isLastRowOnPage = this.items.length === 1 && this.currentPage > 1;
            if (isLastRowOnPage) {
                this.currentPage -= 1;
                return;
            }
            this.fetchItems();
        },
        notifyError(error, fallbackText) {
            this.isLoading = false;
            if (error && error.response) {
                this.handleError(error);
                return;
            }
            this.$vs.notify({
                color: "danger",
                title: "Error",
                iconPack: "feather",
                icon: "icon-x",
                text: (error && error.message) || fallbackText,
            });
        },
    },
    beforeMount() {
        this.gridOptions.getRowHeight = function () {
            return 35;
        };
        this.gridOptions.suppressRowClickSelection = true;
        this.gridOptions.suppressCellSelection = true;
    },
    beforeDestroy() {
        document.body.classList.remove("inspection-modal-open");
    },
};
</script>
